import styled, {css} from 'styled-components';

import ClickOutsideDiv, {ClickOutsideDivProps} from '~/shared/components/ClickOutsideDiv';
import {flipOnLTR, media, rotateOnLTR} from '~/shared/theme/utils';
import ChevronDown from '~/assets/images/icons/chevron-down.svg?react';
import ChevronDownBold from '~/assets/images/icons/chevron-down-bold.svg?react';
import ChevronRight from '~/assets/images/icons/chevron-right.svg?react';
import Button from '~/shared/components/Button';
import {flexColumn, flexCenter, flexCenterVertically} from '~/shared/theme/FlexLayout';

type DropdownWrapperProps = ClickOutsideDivProps & {
  isOpen?: boolean;
};

export const DropdownWrapper = ({isOpen: _ignore, ...rest}: DropdownWrapperProps) => <ClickOutsideDiv {...rest} />;

export const DropdownButtonContainer = styled(Button)`
  ${flexCenter}
  height: 32px;
  border-radius: 2px;
  border: 1px solid ${({theme}) => theme.colors.gray500};
  transition: border 0.05s linear;
  padding: 0;
  margin: 0;
  ${media.minMobile`
    min-width: 97px;
  `}
  ${media.maxMobile`
    border: ${({isOpen}) => (isOpen ? 0 : 1)}px solid ${({theme}) => theme.colors.gray500};
  `}

  &:hover {
    border-color: ${({theme}) => theme.colors.gray200};
  }
`;

export const DropdownButtonTitle = styled.div`
  ${flexCenterVertically}
  height: 16px;
  font-size: inherit;
  letter-spacing: normal;
  min-width: 53px;
  white-space: nowrap;
  color: ${({theme}) => theme.colors.secondary};
`;

export const DropdownContentContainer = styled.div.attrs({
  id: 'dropdown-content',
})`
  -webkit-overflow-scrolling: touch;
  ${flexColumn}
  height: 100%;
  width: 100%;
  position: fixed;
  inset: 0;
  top: 122px;
  margin: 0;
  ${media.minLargeMobile`
    position: absolute;
    top: 35px;
    left: unset;
    right: 0;
    ${({theme}) =>
    theme.isLTR &&
        `
      right: unset;
      left: 0;
    `}
  `}
`;

export const StartIconWrap = styled.div`
  ${flexCenterVertically}
  ${flipOnLTR`
    margin-left: 4px;
  `}
`;

export const BasicArrowRight = styled(ChevronRight)`
  ${rotateOnLTR}
  cursor: pointer;
  display: flex;
`;

const newDropdownArrowStyles = css<{$isOpen: boolean}>`
  transform: rotate3d(0, 0, 1, ${({$isOpen}) => ($isOpen ? 180 : 0)}deg);
  transition: transform 0.15s ease-in-out;
`;

export const DropdownArrow = styled(ChevronDown)`
  ${newDropdownArrowStyles}
`;

export const DropdownArrowBold = styled(ChevronDownBold)`
  ${newDropdownArrowStyles}
`;
